export const pathsImage = [
  {
    id: 1,
    url: "../images/home.svg",
    description: "menu",
    path: "/",
  },
  {
    id: 2,
    url: "../images/Wallet.svg",
    description: "carteira",
    path: "/wallet",
  },
  {
    id: 3,
    url: "../images/details.svg",
    description: "detalhes fatura",
    path: "/details",
  },
  {
    id: 4,
    url: "../images/settings.svg",
    description: "configuração",
    path: "/settings",
  },
];
